import { render, staticRenderFns } from "./BaseSwitch.vue?vue&type=template&id=20de6915&"
import script from "./BaseSwitch.vue?vue&type=script&lang=js&"
export * from "./BaseSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/zp_frontend_vuejs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20de6915')) {
      api.createRecord('20de6915', component.options)
    } else {
      api.reload('20de6915', component.options)
    }
    module.hot.accept("./BaseSwitch.vue?vue&type=template&id=20de6915&", function () {
      api.rerender('20de6915', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BaseSwitch.vue"
export default component.exports